export enum MedicalOrderStatus {
  YET_TO_START_WORK_ON_ORDER = "yet_to_start_work_on_order",
  ORDER_IN_PROGRESS = "order_in_progress",
  ORDER_COMPLETED_BY_HUMAN = "order_completed_by_human",
  ORDER_COMPLETED_BY_AGENT = "order_completed_by_agent",
  /** Agent is actively processing the order; row is non-navigable in worklists. */
  AGENT_IN_PROGRESS = "agent_in_progress",
}

export enum MedicalOrderReviewStatus {
  ORDER_PASSED = "order_passed",
  ORDER_REJECTED = "order_rejected",
  ORDER_IN_REVIEW = "order_in_review",
  AGENT_ORDER_REVIEW_PENDING = "agent_order_review_pending",
  AGENT_ORDER_PASSED_BY_HUMAN = "agent_order_passed_by_human",
  AGENT_ORDER_REJECTED_BY_HUMAN = "agent_order_rejected_by_human",
}
